var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimetable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#3B82F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2559 7.36328H10.7506C8.88012 7.36328 7.36377 8.87963 7.36377 10.7501V23.2554C7.36377 25.1259 8.88012 26.6423 10.7506 26.6423H23.2559C25.1264 26.6423 26.6428 25.1259 26.6428 23.2554V10.7501C26.6428 8.87963 25.1264 7.36328 23.2559 7.36328Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36377 13.7188H26.7094",
    stroke: "#3B82F6",
    strokeWidth: 1.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3498 17.5333C13.3498 16.4341 12.4587 15.543 11.3594 15.543C10.2602 15.543 9.36914 16.4341 9.36914 17.5333C9.36914 18.6325 10.2602 19.5236 11.3594 19.5236C12.4587 19.5236 13.3498 18.6325 13.3498 17.5333Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9054 17.5333C18.9054 16.4341 18.0143 15.543 16.9151 15.543C15.8159 15.543 14.9248 16.4341 14.9248 17.5333C14.9248 18.6325 15.8159 19.5236 16.9151 19.5236C18.0143 19.5236 18.9054 18.6325 18.9054 17.5333Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6251 17.5333C24.6251 16.4341 23.7341 15.543 22.6348 15.543C21.5356 15.543 20.6445 16.4341 20.6445 17.5333C20.6445 18.6325 21.5356 19.5236 22.6348 19.5236C23.7341 19.5236 24.6251 18.6325 24.6251 17.5333Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3498 22.6768C13.3498 21.5776 12.4587 20.6865 11.3594 20.6865C10.2602 20.6865 9.36914 21.5776 9.36914 22.6768C9.36914 23.776 10.2602 24.6671 11.3594 24.6671C12.4587 24.6671 13.3498 23.776 13.3498 22.6768Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9054 22.6768C18.9054 21.5776 18.0143 20.6865 16.9151 20.6865C15.8159 20.6865 14.9248 21.5776 14.9248 22.6768C14.9248 23.776 15.8159 24.6671 16.9151 24.6671C18.0143 24.6671 18.9054 23.776 18.9054 22.6768Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6251 22.6768C24.6251 21.5776 23.7341 20.6865 22.6348 20.6865C21.5356 20.6865 20.6445 21.5776 20.6445 22.6768C20.6445 23.776 21.5356 24.6671 22.6348 24.6671C23.7341 24.6671 24.6251 23.776 24.6251 22.6768Z",
    fill: "white",
    stroke: "#3B82F6",
    strokeWidth: 1.09,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetable);
export default __webpack_public_path__ + "static/media/timetable.3175c33ad0e5922e3b84a631b75004fc.svg";
export { ForwardRef as ReactComponent };